/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme';

type Props = {
  /**
   * The content to render.
   */
  children: React.ReactNode;

  /**
   * Should the content be allowed to scroll when overflow occurs? Defaults to true.
   * There are certain situations where we _don't_ want scrolling to happen e.g. when a dropdown's open menu overflows the content area.
   */
  shouldScroll?: boolean;
};

const Styles = labelStyles('ModalContent', {
  root: (props: Props) => [
    css`
      width: 100%;
      background-color: ${Colors.white};
      padding: 30px;
      border-radius: 0;

      @media screen and (min-width: 650px) {
        width: auto;
        max-width: 750px;
        margin: 30px;
        border-radius: 30px;
        box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.5);
      }
    `,
    props.shouldScroll &&
      css`
        label: -scrollable;

        overflow: auto;

        @media screen and (min-width: 650px) {
          max-height: min(calc(100vh - 80px - 60px), 600px);
        }
      `,
  ],
});

export const ModalContent = (props: Props) => {
  return <div css={Styles.root(props)}>{props.children}</div>;
};

ModalContent.defaultProps = {
  shouldScroll: true,
};
